import { render, staticRenderFns } from "./CcrisDerivatives.vue?vue&type=template&id=39c3fc7e"
import script from "./CcrisDerivatives.vue?vue&type=script&lang=js"
export * from "./CcrisDerivatives.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports